import React, { useCallback, useEffect } from 'react'
import { useRequest } from 'ahooks'
import { VideoUploadForm } from '@/components/Form/Courseware/VideoUploadForm'
import { useCoursewareModal } from '@/hooks/myPages/CoursewareModalProvider'
import { finishUserRecordApi, submitClassWorkApi } from '@/services/class'
import useRawContent from '@/hooks/useRawContent'

type ISeminarCoachUploadProps = {
  onSuccess(): void
}

export default function SeminarCoachUpload({
  onSuccess,
}: ISeminarCoachUploadProps) {
  const { courseware, info, requestClose, classId } = useCoursewareModal()

  const { renderReplacedVideo, parsed } = useRawContent({
    content: courseware.content || '',
  })


  // 2026-09 이관: 업로드가 전부 S3 로 가므로 언어와 무관하게 `aws` 입니다.
  //   예전에는 한국만 S3 였고 나머지는 알리바바 OSS 라 언어로 갈랐습니다.
  const platform = 'aws'

  const submitData = useCallback(
    async data => {
      try {
        await submitClassWorkApi(classId, info.id, {
          content: data.url,
          file_path: data.file_name,
          file_upload_platform: data.file_upload_platform || platform,
          file_size: data.file_size,
        })
        await finishUserRecordApi(classId, info.id)
        onSuccess()
      } catch (e) {
        console.error(e)
      }
    },
    [classId, info.id, onSuccess, platform]
  )

  const { runAsync, loading: submitting } = useRequest(submitData, {
    manual: true,
  })

  useEffect(() => {
    renderReplacedVideo()
  }, [renderReplacedVideo])
  return (
    <div className={'overflow-auto'}>
      <div
        className="w-full gga-page-view"
        dangerouslySetInnerHTML={{ __html: parsed }}
      />
      <VideoUploadForm
        submitting={submitting}
        requestClose={requestClose}
        onSubmit={runAsync}
      />
    </div>
  )
}
